import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import CurrencyFormat from "react-currency-format";
import { useStateContext } from "../../../../context/StateContext_US";
import { useTranslation } from "react-i18next";

const SubtotalCheckout = () => {
  const { t, i18n } = useTranslation();
  const {
    getBasketQuantity,
    getSubtotal,
    getShipping,
    getBasketTotal,
    taxPrice,
  } = useStateContext();
  const [subtotal, setSubtotal] = useState(getSubtotal());
  const [total, setTotal] = useState(getBasketTotal());

  useEffect(() => {
    setSubtotal(getSubtotal());
    setTotal(getBasketTotal());
  }, [getBasketTotal, getSubtotal]);

  useEffect(() => {
    console.log("getSubtotal()", getSubtotal());
    console.log("getShipping()", getShipping());
  }, [getShipping, getSubtotal]);

  return (
    <Box sx={{ py: 2 }}>
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
          }}
        >
          <Box>
            {t("subtotal")} ({getBasketQuantity()}{" "}
            {getBasketQuantity() > 1 ? t("items") : t("item")}):
          </Box>

          <CurrencyFormat
            renderText={(subtotal) => <strong>{subtotal}</strong>}
            decimalScale={2}
            value={subtotal}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
            pt: 2,
          }}
        >
          <Box>{t("shipping")}:</Box>

          <Box>
            <strong>
              {+getShipping() > 0 ? (
                <CurrencyFormat
                  renderText={(shipping) => <strong>{shipping}</strong>}
                  decimalScale={2}
                  value={getShipping()}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />
              ) : (
                "Free Shipping"
              )}
            </strong>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
            pt: 2,
          }}
        >
          <Box>{t("tax")}:</Box>
          <Box>
            <CurrencyFormat
              renderText={(taxPrice) => <strong>{taxPrice}</strong>}
              decimalScale={2}
              value={taxPrice}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </Box>
        </Box>
        <Box
          sx={{
            paddingTop: "10px",
            width: 1,
            borderBottom: "1px solid black",
            pb: "4px",
          }}
        ></Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
            pt: 2,
          }}
        >
          <Box>{t("total")}:</Box>
          <Box>
            <CurrencyFormat
              renderText={(total) => <strong>{total}</strong>}
              decimalScale={2}
              value={total}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </Box>
        </Box>

        {/* <FormControlLabel
							control={<Checkbox />}
							label="This order contains a gift"
						/> */}
        {/* <small>
							<input type="checkbox" /> This order contains a gift
						</small> */}
        {/* <Box sx={{ pt: 10 }}>
							<HashLink smooth to="/checkout">
								<Button
									variant="contained"
									sx={{
										width: 1,
										borderRadius: 0,
										backgroundColor: "black",
										py: 2,
									}}
								>
									Proceed to Checkout
								</Button>
							</HashLink>
						</Box> */}
      </>
      {/* )} decimalScale={2}
			value={value}
			displayType={"text"}
			thousandSeparator={true}
			prefix={"$"}
			// value={getBasketTotal(basket)}
			/> */}
    </Box>
  );
};

export default SubtotalCheckout;
